/* istanbul ignore file */

import React, { MouseEvent } from 'react';
import { getProductImageURL, PrimaryLabel } from '@noths/polaris-client-ribbons-design-system';
import Image from 'next/image';

import { Product } from 'src/types';
import { PRODUCT_IMAGES_SECTION_LABEL_SINGLE } from '../constants';
import { OpenModalPayload } from '../types';
import * as styles from '../styles/ProductImages.styles';

interface SingleProductImageProps {
  product: Product;
  onOpenModal: (payload: OpenModalPayload) => void;
}

const handleImageClick = (
  e: MouseEvent<HTMLAnchorElement>,
  onOpenModal: SingleProductImageProps['onOpenModal'],
) => {
  e.preventDefault();
  onOpenModal({ location: 'Main image' });
};

export const SingleProductImage = ({
  product: { images, isNew, onSale, salePercentage, purchasable, available, availability },
  onOpenModal,
}: SingleProductImageProps) => (
  <section aria-label={PRODUCT_IMAGES_SECTION_LABEL_SINGLE} css={styles.imagesWrapper}>
    <div css={styles.mainImageWrapperNoThumbnails}>
      <a
        href={getProductImageURL(images[0].href, 'original')}
        onClick={(e) => handleImageClick(e, onOpenModal)}
        css={styles.mainImageLink}
      >
        <Image
          src={getProductImageURL(images[0].href, 'original')}
          alt={images[0].title}
          css={styles.mainImage}
          layout="fill"
          priority={true}
          unoptimized
        />
      </a>
      <PrimaryLabel
        className="product-image__label"
        css={styles.productLabel}
        isNew={isNew}
        onSale={onSale}
        salePercentage={salePercentage}
        unavailable={!available && availability === 'suspended'}
        hasStock={purchasable}
      />
    </div>
  </section>
);
